module.exports = __webpack_public_path__ + "static/img/default.53b1b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/default.jpg
// module id = JoZn
// module chunks = 1